import { CodedProperty, NamedProperty } from "sprint-common-web";

import { AncillaryDocumentResponse } from "../../../common/api/catalogue-api/ancillary/AncillaryDocumentResponse";
import { BuzzContentReference } from "../../../common/types/BuzzContentReference";
import { ContentSource } from "../../../common/types/ContentSource";

export interface AncillaryItem {
    id: string;
    title: string;
    orphaned: boolean;
    source: ContentSource;
    buzz?: BuzzContentReference;
    merged?: boolean;
    mergedTargetId?: string;
    distributor: NamedProperty;
    isModified?: boolean;
    airlines: CodedProperty[];
    versionType: NamedProperty;
    versionBuzzId?: string;
}

const getAirlines = (airlines: CodedProperty[]): CodedProperty[] => {
    return airlines.map((airline: CodedProperty) => {
        return {
            id: airline.id,
            name: airline.name,
            code: airline.code
        };
    });
};

export const mapToAncillaryItem = (item: AncillaryDocumentResponse): AncillaryItem => {
    return {
        id: item.id,
        title: item.title,
        distributor: item.version.distributor,
        orphaned: item.orphaned,
        source: item.source,
        buzz: item.buzz,
        versionType: item.version.type,
        versionBuzzId: item.version.buzzId,
        airlines: getAirlines(item.version.airlines),
        merged: !!item.mergedTargetId,
        mergedTargetId: item.mergedTargetId
    };
};
